// const baseUrl = "https://itetlax.org.mx/assets/img/";

export const modalsInitData = [

  {
    id: 1,
    imgLink: "https://itetlax.org.mx/assets/img/imgPopup/Orden2.png",
    url: "",
    linkToo: "",
  },

  {
    id: 2,
    imgLink: "https://itetlax.org.mx/assets/img/imgPopup/Orden1.png",
    url: "",
    linkToo: "",
  },

  /* {
     id: 2,
     imgLink: "https://itetlax.org.mx/assets/img/imgPopup/orden1_3.png",
     url: "",
     linkToo: "",
  },
   {
     id: 3,
   imgLink: "https://itetlax.org.mx/assets/img/imgPopup/orden1_2.png",
     url: "",
     linkToo: "",
  },
  {
     id: 4,
     imgLink: "https://itetlax.org.mx/assets/img/imgPopup/orden1_1.png",
     url: "",
     linkToo: "",
  },
  */

];

const ModalComponent = () => {
  return (
    <div>
      {modalsInitData.map((modal) => (
        <div key={modal.id}>
          <img
            src={modal.imgLink}
            alt="Modal"
            style={{
              maxWidth: "100%",
              maxHeight: "400px",
              width: "auto",
              height: "auto",
            }} // Establece el tamaño máximo aquí
          />
        </div>
      ))}
    </div>
  );
};

export default ModalComponent;
